export default "__VITE_ASSET__BJ155WTt__"